export default "__VITE_ASSET__BR8t6Zr3__"